const { create } = require('zustand');

export const useGoalsSettingsStore = create((set) => ({
  openSettings: () => set(() => ({ settingsModalOpen: true })),
  closeSettings: () => set(() => ({ settingsModalOpen: false })),
}));
